import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { createTracker } from 'redux-segment';
import { pageMapper } from '@surfline/web-common/dist/segment';

import user from '../reducers/user';
import login from '../reducers/login';
import facebook from '../reducers/facebook';
import entitlements from '../reducers/entitlements';
import plans from '../reducers/plans';
import interactions from '../reducers/interactions';
import auth from '../reducers/auth';
import subscription from '../reducers/subscription';
import coupon from '../reducers/coupon';
import duplicateCard from '../reducers/duplicateCard';
import cards from '../reducers/cards';
import geo from '../reducers/geo';
import features from '../reducers/features';
import brand from '../reducers/brand';

export default (initialState, history) => {
  const enhancer = compose(
    applyMiddleware(
      thunkMiddleware,
      createTracker(pageMapper),
      routerMiddleware(history),
    ),
  );

  const reducer = combineReducers({
    brand,
    routing: routerReducer,
    auth,
    entitlements,
    plans,
    user,
    login,
    facebook,
    subscription,
    interactions,
    coupon,
    duplicateCard,
    cards,
    form: formReducer,
    geo,
    flags: features,
  });

  const store = createStore(reducer, initialState, enhancer);

  return store;
};
